import { ParallaxSection } from '../components/ParallaxSection'

const values = [
  {
    name: 'Integrity',
    description: "Speaking truth, especially when it's hard.",
  },
  {
    name: 'Adventure',
    description: 'Enjoying the world we strive to protect.',
  },
  {
    name: 'Manaakitanga',
    description: 'Going above and beyond for clients and colleagues.',
  },
  {
    name: 'Urutau',
    description: 'Constantly learning and achieving excellence in a changing environment.',
  },
  {
    name: 'Kotahitanga',
    description: 'United in making positive change.',
  },
]

const ValuesSection = () => {
  return (
    <ParallaxSection
      height="h-auto"
      image="/website/ui-values-bg.webp"
      overlayOpacity="bg-black/30"
    >
      <div className="flex items-center justify-center w-full h-full py-20">
        <div className="z-10 max-w-5xl px-6 text-left">
          <h1 className="mb-12 text-4xl font-light leading-tight text-text-inverted sm:text-5xl lg:text-h1Light">
            Our work is guided by five core values
          </h1>

          <div className="space-y-6">
            {values.map((value) => (
              <div key={value.name} className="text-text-inverted">
                <h3 className="text-xl font-semibold lg:text-2xl">
                  {value.name}
                  <span className="ml-3 font-light text-text-inverted/90">{value.description}</span>
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ParallaxSection>
  )
}

export default ValuesSection
